import { colors } from '@indeed/ifl-tokens';
import { Platform, StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    defaultContainer: {
        gap: 16,
    },
    compactContainer: {
        gap: 12,
    },
    inputBox: {
        alignItems: 'flex-start',
    },
    updatedWrapper: {
        width: '100%',
        gap: 16,
    },
    payInputWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: colors.neutral[700],
        borderStyle: 'solid',
    },
    payInputWrapperInvalid: {
        borderColor: colors.alert[800],
        shadowColor: colors.alert[800],
    },
    payInput: {
        flexGrow: 1,
        margin: 0,
        borderRadius: 8,
        fontSize: 16,
        fontWeight: '400',
        letterSpacing: 0,
        lineHeight: 24,
        color: colors.neutral[1000],
        paddingTop: Platform.OS === 'ios' ? 0 : 9,
        paddingRight: 12,
        paddingBottom: 9,
        paddingLeft: 4,
        minHeight: 44,
        minWidth: 0,
        borderWidth: 0,
    },
    payInputCurrency: {
        minWidth: 24,
        color: colors.neutral[700],
        justifyContent: 'center',
        paddingLeft: 8,
        marginRight: 4,
        textAlign: 'center',
        fontSize: 16,
    },
});
